const logotext = "\u03C0";
const logo_src_light = "/images/JL Logo Transparent.png";
const logo_src_dark = "/images/JL Logo BNW Transparent.png";
const meta = {
    title: "Jared Lim",
    description: "I’m Jared Junyoung Lim.",
};

const introdata = {
    title: "I’m Jared Lim",
    animated: {
        first: "I love problem solving and fast execution",
    },
    description: "Machine Learning Engineer at Google, working on Ranking Algorithms for YouTube Shorts Trends.",
    your_img_url: "assets/images/spiral_based_on_prime.gif",
};

const dataabout = {
    title: "Introduction",
    aboutme: [
        "My name is Jared Junyoung Lim, and I'm a Machine Learning Engineer at Google. I graduated from Cornell University, College of Engineering, where I received my M.Eng. and B.S. degree in Computer Science with a minor in Mathematics.",
        "I love bringing big impacts in the industry with fast iterations, particularly enjoying the problems that involve mathematics, statistics, and programming.",
    ],
};

const education = [{
    degree: "M.Eng. Computer Science",
    institution: "Cornell University",
    date: "Jan. 2020 - Dec. 2020",
    descriptions: [
        "Advisor: Prof. David Bindel",
        "Topic: Approximation Space Construction for Learning-to-Cluster (LTC) Algorithms",
    ],
},
{
    degree: "B.S. Computer Science",
    institution: "Cornell University",
    date: "Aug. 2016 - Dec. 2019",
    descriptions: [
        "Minor in Mathematics",
        "Activities & Societies: Cornell Data Science, Cornell AppDev, Theta Tau Engineering Fraternity",
    ],
}]

const worktimeline = [{
        team: "YouTube Shorts Trends",
        jobtitle: "MLE",
        where: "Google",
        date: "Oct. 2023 - Present",
    },
    {
        team: "On-Device Machine Learning",
        jobtitle: "SWE",
        where: "Google",
        date: "Apr. 2021 - Sept. 2023",
    },
];

const internship = {
    text: "Internships: Google TensorFlow Lite (Summer 2020), AWS Automated Reasoning Group (Summer 2019), Google Android (Spring 2019), Workday Automated Regression Platform (Summer 2018), and an AI startup (Summer 2017)."
}

const skills = [{
        name: "Python",
        value: 90,
    },
    {
        name: "Djano",
        value: 85,
    },
    {
        name: "Javascript",
        value: 80,
    },
    {
        name: "React",
        value: 60,
    },
    {
        name: "Jquery",
        value: 85,
    },
];

const misc = [{
        title: "Project Euler",
        description: "Don't have much time nowadays, but once in a while, I pick a problem and solve. My biggest guilty pleasure :)",
    },
    {
        title: "Rubik's Cube",
        description: "My main hobby back in high school. Personal record at 10.86 seconds for solving 3x3.",
    },
];

const dataportfolio = [{
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/800/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/600/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },

    {
        img: "https://picsum.photos/400/600/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/550/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
];

const datastudio = [
    {
        img: "/images/studio/hanbok.jpg",
        description: "Mallard and Hanbok",
        chips: ["Watercolor"],
    },
    {
        img: "/images/studio/Jesus.jpg",
        description: "Crucifixion",
        chips: ["Papercutting"],
    },
    {
        img: "/images/studio/tiger.jpg",
        description: "Carnivore 1",
        chips: ["Metal Etching"],
    },
    {
        img: "/images/studio/eagle2 cropped.jpg",
        description: "Gaze",
        chips: ["Dessin"],
    },
    {
        img: "/images/studio/hands.jpg",
        description: "Hands Pop",
        chips: ["Crayon", "Pen", "Papercutting"],
    },
    {
        img: "/images/studio/wilde1.jpg",
        description: "Wilde 1",
        chips: ["Watercolor"],
    },
    {
        img: "/images/studio/tree.jpg",
        description: "Childhood",
        chips: ["Watercolor"],
    },
    {
        img: "/images/studio/wilde2.jpg",
        description: "Wilde 2",
        chips: ["Watercolor"],
    },
    {
        img: "/images/studio/eagle.jpg",
        description: "Carnivore 2",
        chips: ["Metal Etching"],
    },
]

const contactConfig = {
    YOUR_EMAIL: "jl3248@cornell.edu",
    // YOUR_FONE: "(555)123-4567",
    description: "Feel free to get in touch. You can email me at:",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofiles = {
    github: "https://github.com/JunyoungLim",
    linkedin: "https://linkedin.com/in/junyoung-lim",
};
export {
    meta,
    dataabout,
    dataportfolio,
    datastudio,
    internship,
    education,
    worktimeline,
    skills,
    misc,
    introdata,
    contactConfig,
    socialprofiles,
    logotext,
    logo_src_light,
    logo_src_dark,
};